import type { PropsWithChildren } from 'react';

import { AttentionTriangleIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './FaceMatchModal.module.sass';

interface FaceMatchModalProps extends PropsWithChildren {
  onClick: VoidFunction;
  closeModal: VoidFunction;
  title: string;
  message: string;
}

function FaceMatchModal({
  children,
  closeModal,
  onClick,
  title,
  message,
}: FaceMatchModalProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={st.Root}>
      <div className={st.ModalHeader}>
        <div className={st.HeaderTitle}>
          <div className={st.HeaderIcon}>
            <AttentionTriangleIcon />
          </div>
          <span
            className={st.Title}
            data-testid="FaceMatchModal.header.title"
          >
            {title}
          </span>
        </div>
        <div className={st.HeaderMessage}>
          <span
            className={st.Message}
            data-testid="FaceMatchModal.header.message.title"
          >
            {message}
          </span>
        </div>
      </div>
      <div className={st.ModalBody}>
        {children}
      </div>
      <div className={st.ModalFooter}>
        <div className={st.ButtonWrapper}>
          <Control.Button
            data-testid="FaceMatchModal.button.add anyway"
            fullWidth
            kind="attention"
            onClick={onClick}
            variant="filled"
          >
            {t('faces:modal.button.add anyway')}
          </Control.Button>
        </div>
        <div className={st.ButtonWrapper}>
          <Control.Button
            data-testid="FaceMatchModal.button.close modal"
            fullWidth
            kind="secondary"
            onClick={closeModal}
            variant="outlined"
          >
            {t('shared:кнопка.отмена')}
          </Control.Button>
        </div>
      </div>
    </div>
  );
}

export default FaceMatchModal;
